import styled from 'styled-components'

const WrapButtons = styled.div`
  display: flex;
  width: 100%;
  > :nth-child(1) {
    width: 100%;
  }
`

export { WrapButtons }
